export const formatScore = (score: number): string => {
  if (score == 0) {
    return "E";
  }
  if (score < 0) {
    return score.toString();
  }
  if (score > 0) {
    return "+" + score.toString();
  } else {
    return "?";
  }
};

export const ordinalValue = (rank: number): string => {
  var j = rank % 10,
    k = rank % 100;
  if (j == 1 && k != 11) {
    return "st";
  }
  if (j == 2 && k != 12) {
    return "nd";
  }
  if (j == 3 && k != 13) {
    return "rd";
  }
  return "th";
};
